import { IconRectangle } from '@tabler/icons-react';
import { memo, useCallback, useMemo } from 'react';
import PlayerMenuTooltip from '@/App/remotion/components/PlayerMenus/PlayerMenuTooltip';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { classnames } from '@/libs/utils';
import { LottieElement, LottieStyleProperties } from '@/App/remotion/MainPlayer/types/Element/LottieElement';
import { changeElementPositionHandler } from '@/Pages/Clip/ClipPlayer/ClipAssets/handlers';
import { DEFAULT_LOTTIE_CONTAINER_STYLE, DEFAULT_LOTTIE_STYLE } from '@/Pages/Clip/ClipPlayer/ClipAssets/constants';

function LottieElementFill({ selectedElement }: { selectedElement: LottieElement }) {
  const { clipId, clipData } = useClipsContext();

  const isFilled = useMemo(() => {
    return selectedElement?.style?.preserveAspectRatio === 'xMidYMid slice';
  }, [selectedElement?.style?.preserveAspectRatio]);

  const toggleFitMode = useCallback(() => {
    if (!selectedElement?.id) {
      return;
    }

    if (isFilled) {
      const newContainerStyle: LottieStyleProperties = {
        ...DEFAULT_LOTTIE_CONTAINER_STYLE
      };

      const newStyle: LottieStyleProperties = {
        ...DEFAULT_LOTTIE_STYLE,
        preserveAspectRatio: 'xMidYMid meet'
      };

      changeElementPositionHandler(clipData, clipId, selectedElement.id, {
        containerStyle: newContainerStyle,
        style: newStyle
      });
    } else {
      // Switch to fill mode (cover - xMidYMid slice with 90deg rotation)
      const newContainerStyle: LottieStyleProperties = {
        width: '100%',
        height: '100%',
        top: '0%',
        left: '0%'
      };

      const newStyle: LottieStyleProperties = {
        ...DEFAULT_LOTTIE_STYLE,
        preserveAspectRatio: 'xMidYMid slice'
      };

      changeElementPositionHandler(clipData, clipId, selectedElement.id, {
        containerStyle: newContainerStyle,
        style: newStyle
      });
    }
  }, [clipId, selectedElement?.id, clipData, isFilled]);

  return (
    <button
      onClick={toggleFitMode}
      data-testid="lottie-element-fill-toggle"
      className={classnames('group/button flex size-10 items-center justify-center rounded-md')}
    >
      <IconRectangle size={20} />
      <PlayerMenuTooltip content={isFilled ? 'Fit frame' : 'Fill frame'} />
    </button>
  );
}

export default memo(LottieElementFill);
